// Add to Cart for product grid items (AJAX, triggers cart drawer)
window.ThemeProductGridAddToCart = function(form) {
  var formData = new FormData(form);
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
  .then(function(response) {
    if (!response.ok) throw response;
    return response.json();
  })
  .then(function() {
    document.body.dispatchEvent(new CustomEvent('label:modalcart:afteradditem'));
  });
};

console.log('✅ custom.js loaded');